/* ==========================================================================
   MEHER TEXTILE — Theme JS
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- mobile nav ------------------------------------------------------ */
  var toggle   = document.querySelector('.menu-toggle');
  var mobNav   = document.querySelector('.mobile-nav');
  var overlay  = document.querySelector('.mobile-overlay');
  var closeBtn = document.querySelector('.mobile-close');
  function openNav(){ mobNav.classList.add('open'); overlay.classList.add('open'); }
  function closeNav(){ mobNav.classList.remove('open'); overlay.classList.remove('open'); }
  if (toggle) toggle.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  /* ---- scroll reveal ----------------------------------------------------*/
  var revealEls = document.querySelectorAll('.reveal, .underline-draw');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ---- header shrink on scroll (subtle) ---------------------------------*/
  var header = document.querySelector('.site-header');
  var lastY = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (header) header.style.boxShadow = y > 40 ? '0 8px 24px rgba(0,0,0,.35)' : 'none';
    lastY = y;
  });

  /* ---- money formatting (shared) -----------------------------------------*/
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var fmt = window.themeMoneyFormat || 'Rs. {{amount}}';
    var withThousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withThousands)
               .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* ---- cart count fetch --------------------------------------------------*/
  function refreshCartCount(cartData) {
    var apply = function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    };
    if (cartData) { apply(cartData); return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(apply).catch(function () {});
  }
  refreshCartCount();

  /* ====================================================================
     CART DRAWER — opens automatically after anything is added to cart
     ==================================================================== */
  var drawer        = document.querySelector('[data-cart-drawer]');
  var drawerOverlay  = document.querySelector('[data-cart-drawer-overlay]');
  var drawerBody     = document.querySelector('[data-cart-drawer-body]');
  var drawerEmpty    = document.querySelector('[data-cart-drawer-empty]');
  var drawerFooter   = document.querySelector('[data-cart-drawer-footer]');
  var drawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  var drawerCloseBtn = document.querySelector('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderCartDrawer(cart) {
    if (!drawerBody) return;
    refreshCartCount(cart);

    if (!cart.items.length) {
      drawerBody.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
      if (drawerFooter) drawerFooter.style.display = 'none';
      return;
    }

    if (drawerFooter) drawerFooter.style.display = 'block';
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);

    drawerBody.innerHTML = cart.items.map(function (item) {
      var propsHtml = '';
      var bundleTag = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          var val = item.properties[key];
          if (!val) return;
          if (key === '_bundle_id') {
            bundleTag = '<span class="cart-drawer-item-bundle-tag">Bundle</span>';
          } else if (key.indexOf('_') !== 0) {
            propsHtml += '<div class="cart-drawer-item-prop">' + key + ': ' + val + '</div>';
          }
        });
      }
      return (
        '<div class="cart-drawer-item" data-key="' + item.key + '">' +
          '<img src="' + (item.image || '') + '&width=160" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '">' +
          '<div>' +
            '<div class="cart-drawer-item-title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cart-drawer-item-variant">' + item.variant_title + '</div>' : '') +
            propsHtml + bundleTag +
            '<div class="cart-drawer-item-qty">' +
              '<button type="button" data-drawer-qty-minus aria-label="Decrease quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-drawer-qty-plus aria-label="Increase quantity">+</button>' +
              '<button type="button" class="cart-drawer-item-remove" data-drawer-remove>Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer-item-price">' + formatMoney(item.line_price) + '</div>' +
        '</div>'
      );
    }).join('');
  }

  function fetchAndRenderCartDrawer() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); return cart; });
  }

  function openCartDrawerWithFreshData() {
    fetchAndRenderCartDrawer().then(openCartDrawer);
  }

  function changeCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); });
  }

  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var row = e.target.closest('[data-key]');
      if (!row) return;
      var key = row.dataset.key;
      var qtyEl = row.querySelector('.cart-drawer-item-qty span');
      var currentQty = parseInt(qtyEl.textContent, 10) || 0;

      if (e.target.closest('[data-drawer-qty-plus]')) {
        changeCartLine(key, currentQty + 1);
      } else if (e.target.closest('[data-drawer-qty-minus]')) {
        changeCartLine(key, Math.max(0, currentQty - 1));
      } else if (e.target.closest('[data-drawer-remove]')) {
        changeCartLine(key, 0);
      }
    });
  }

  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawerWithFreshData();
    });
  });
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeCartDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* ---- product gallery thumbs -------------------------------------------*/
  document.querySelectorAll('.product-thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.product-gallery-main img');
      if (mainImg) mainImg.src = thumb.dataset.full || thumb.src;
      document.querySelectorAll('.product-thumbs img').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ====================================================================
     BUNDLE BUILDER — flexible minimum-to-maximum mode
     Shopper picks anywhere from `min` to `max` pieces (colours/products)
     pulled from a whole collection. Add to Cart stays disabled below the
     minimum and locks further picks once the maximum is reached. Each
     piece is added as its own real variant line item (so Shopify
     inventory stays accurate) tagged with a shared bundle id so they
     read as one bundle in the cart.
     ==================================================================== */
  var bundleBox = document.querySelector('[data-bundle-box]');
  if (bundleBox) {
    var min        = parseInt(bundleBox.dataset.min, 10) || 3;
    var max        = parseInt(bundleBox.dataset.max, 10) || 8;
    var swatches   = Array.prototype.slice.call(bundleBox.querySelectorAll('.swatch'));
    var countEl    = bundleBox.querySelector('[data-bundle-count]');
    var progressEl = bundleBox.querySelector('[data-bundle-progress]');
    var listEl     = bundleBox.querySelector('[data-bundle-selected-list]');
    var totalEl    = bundleBox.querySelector('[data-bundle-total]');
    var addBtn     = document.querySelector('[data-bundle-add]');
    var errorEl    = document.querySelector('[data-bundle-error]');
    var toastEl    = document.querySelector('[data-bundle-toast]');

    var selected = []; // array of {id, name, image, price, comparePrice, qty}

    function totalPieces() {
      return selected.reduce(function (n, i) { return n + i.qty; }, 0);
    }

    function findSwatch(id) {
      return swatches.filter(function (s) { return s.dataset.variantId === id; })[0];
    }

    function addPiece(id) {
      if (totalPieces() >= max) {
        errorEl.textContent = 'Maximum ' + max + ' pieces per bundle. Remove one to swap it.';
        errorEl.classList.add('show');
        return;
      }
      var existing = selected.filter(function (s) { return s.id === id; })[0];
      if (existing) {
        existing.qty += 1;
      } else {
        var sw = findSwatch(id);
        if (!sw) return;
        selected.push({
          id: id,
          name: sw.dataset.variantName,
          image: sw.dataset.variantImage,
          price: sw.dataset.variantPrice,
          comparePrice: sw.dataset.variantComparePrice || sw.dataset.variantPrice,
          qty: 1
        });
      }
      render();
    }

    function removePiece(id, all) {
      var idx = selected.findIndex(function (s) { return s.id === id; });
      if (idx === -1) return;
      if (all || selected[idx].qty <= 1) selected.splice(idx, 1);
      else selected[idx].qty -= 1;
      render();
    }

    var preselectId = bundleBox.dataset.preselectId;
    if (preselectId && findSwatch(preselectId)) addPiece(preselectId);

    function render() {
      var pieces = totalPieces();

      countEl.innerHTML = '<strong>' + pieces + '</strong> selected';
      progressEl.style.width = Math.min(100, (pieces / min) * 100) + '%';

      listEl.innerHTML = '';
      selected.forEach(function (item) {
        var chip = document.createElement('span');
        chip.className = 'chip';
        chip.innerHTML = item.name + (item.qty > 1 ? ' <em class="chip-qty">×' + item.qty + '</em>' : '') +
          ' <button type="button" aria-label="Remove">×</button>';
        chip.querySelector('button').addEventListener('click', function () { removePiece(item.id, true); });
        listEl.appendChild(chip);
      });

      var totalCents = selected.reduce(function (sum, i) {
        return sum + ((parseInt(i.price, 10) || 0) * i.qty);
      }, 0);

      var originalTotalCents = selected.reduce(function (sum, i) {
        return sum + ((parseInt(i.comparePrice, 10) || parseInt(i.price, 10) || 0) * i.qty);
      }, 0);

      totalEl.textContent = formatMoney(totalCents);

      var originalTotalEl = bundleBox.querySelector('[data-bundle-original-total]');
      if (originalTotalEl) {
        if (originalTotalCents > totalCents && pieces > 0) {
          originalTotalEl.textContent = formatMoney(originalTotalCents);
          originalTotalEl.style.display = 'inline';
        } else {
          originalTotalEl.style.display = 'none';
        }
      }

      swatches.forEach(function (sw) {
        var id = sw.dataset.variantId;
        var item = selected.filter(function (s) { return s.id === id; })[0];
        var qty = item ? item.qty : 0;

        sw.classList.toggle('selected', qty > 0);

        var orderEl = sw.querySelector('.swatch-order');
        if (orderEl) orderEl.textContent = qty > 0 ? ('×' + qty) : '';

        var qtyValEl = sw.querySelector('[data-qty-value]');
        if (qtyValEl) qtyValEl.textContent = qty;

        var plusBtn = sw.querySelector('[data-qty-plus]');
        if (plusBtn) plusBtn.disabled = pieces >= max;

        if (qty === 0 && pieces >= max) sw.classList.add('disabled');
        else sw.classList.remove('disabled');
      });

      var belowMin = pieces < min;
      var atMax    = pieces >= max;
      addBtn.disabled = belowMin;

      if (belowMin) {
        addBtn.textContent = 'Select ' + (min - pieces) + ' more to unlock Add to Cart';
      } else if (atMax) {
        addBtn.textContent = 'Add ' + pieces + ' Pieces to Cart — ' + formatMoney(totalCents) + ' (Max Reached)';
      } else {
        addBtn.textContent = 'Add ' + pieces + ' Pieces to Cart — ' + formatMoney(totalCents);
      }
      errorEl.classList.remove('show');
    }

    swatches.forEach(function (sw) {
      var id = sw.dataset.variantId;

      var plusBtn  = sw.querySelector('[data-qty-plus]');
      var minusBtn = sw.querySelector('[data-qty-minus]');

      if (plusBtn) {
        plusBtn.addEventListener('click', function (e) { e.stopPropagation(); addPiece(id); });
      }
      if (minusBtn) {
        minusBtn.addEventListener('click', function (e) { e.stopPropagation(); removePiece(id, false); });
      }

      sw.addEventListener('click', function (e) {
        if (e.target.closest('[data-qty-stepper]')) return;
        var item = selected.filter(function (s) { return s.id === id; })[0];
        if (item) removePiece(id, true);
        else addPiece(id);
      });
    });

    render();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (totalPieces() < min) return;
        addBtn.disabled = true;
        var origText = addBtn.textContent;
        addBtn.textContent = 'Adding…';

        var bundleId = 'bundle-' + Date.now();
        var pieceCount = totalPieces();
        var items = selected.map(function (item) {
          return {
            id: parseInt(item.id, 10),
            quantity: item.qty,
            properties: {
              'Bundle': 'Custom Bundle (' + pieceCount + ' pcs)',
              '_bundle_id': bundleId,
              'Chosen Colour': item.name
            }
          };
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw e; });
            return r.json();
          })
          .then(function () {
            if (toastEl) {
              toastEl.textContent = 'Bundle added — ' + pieceCount + ' pieces in your cart.';
              toastEl.classList.add('show');
              setTimeout(function () { toastEl.classList.remove('show'); }, 3200);
            }
            selected = [];
            render();
            openCartDrawerWithFreshData();
          })
          .catch(function (e) {
            errorEl.textContent = (e && e.description) ? e.description : 'Something went wrong adding this bundle. Please try again.';
            errorEl.classList.add('show');
          })
          .finally(function () {
            addBtn.disabled = totalPieces() < min;
            if (totalPieces() >= min) addBtn.textContent = origText;
          });
      });
    }
  }

  /* ---- simple (non-bundle) product add-to-cart --------------------------*/
  var simpleForm = document.querySelector('[data-simple-product-form]');
  if (simpleForm) {
    simpleForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(simpleForm);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () {
          var toastEl = document.querySelector('[data-bundle-toast]');
          if (toastEl) {
            toastEl.textContent = 'Added to your cart.';
            toastEl.classList.add('show');
            setTimeout(function () { toastEl.classList.remove('show'); }, 3000);
          }
          openCartDrawerWithFreshData();
        });
    });
  }

  /* ---- cart quantity updates --------------------------------------------*/
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.dataset.cartQty;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); });
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.cartRemove, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });
});
